import { change } from 'redux-form';

import { messageLevel } from '../../lib/MessagePopupOld';
import { toggleMessage } from '../action';
import { receive_kwargs, receive_masks, receive_past } from '../receive';

export const ENABLE_TEMPORAL_RANGE = 'ENABLE_TEMPORAL_RANGE';
export const enableTemporalRange = (enabled) => ({
  type: ENABLE_TEMPORAL_RANGE,
  enabled,
});

export const ENABLE_TEMPORAL_MAX_RANGE = 'ENABLE_TEMPORAL_MAX_RANGE';
export const updateTemporalMaxRange = (start, end) => ({
  type: ENABLE_TEMPORAL_MAX_RANGE,
  start,
  end,
});

export const LOAD_MASKS = 'LOAD_MASKS';
export const doLoadMasks = (masks) => ({
  type: LOAD_MASKS,
  masks,
});

export const loadMasks = (formValueLabel) => {
  return async (dispatch) => {
    try {
      const kwargs = await receive_kwargs();
      const database = kwargs.climate_database;

      const json = await receive_masks(database);
      const { masks } = json;
      await dispatch(doLoadMasks(masks));
      await dispatch(change(formValueLabel, 'maskid', String(masks[0].value)));
    } catch (error) {
      dispatch(toggleMessage('Could not communicate with server.', messageLevel.ERROR));
    }
  };
};

export const updateTemporalRange = ({database, model, ensemble, experiment, frequency, variables}) => {
  return async (dispatch) => {
    try {
      const json = await receive_past({database, model, ensemble, experiment, frequency, variables});
      const { start, end } = json;
      if (start == null && end == null) {
        return null;
      }
      return { start, end };
    } catch (error) {
      dispatch(toggleMessage('Could not retrieve temporal range information.', messageLevel.ERROR));
    }
    return null;
  };
};
